import { types as t, getParent, hasParent, getSnapshot, types, resolvePath } from '@invisr/mobx-state-tree'
import walk from '../../utils/walkObj'

export const whereUsed = (ids, root) => {
  const used = {}

  const snap = getSnapshot(root)
  walk(snap, (path, node) => {
    if (!node) return
    if (ids.includes(node.id)) return true
    if (!(node.dataSource || node.dataSourceId || node.recordType)) return
    for (const id of ids) {
      if ([node.dataSource, node.dataSourceId, node.recordType].includes(id)) {
        used[id] = used[id] || []
        try {
          used[id].push(resolvePath(root, '/' + path.join('/')))
        } catch (e) {
          // empty
        }
      }
    }
  })
  return used
}

export default types
  .model('WhereUsed', {
    lastModifiedBy: t.maybeNull(t.string),
    lastModified: t.maybeNull(t.number)
  })
  .views(self => ({
    whereUsed () {
      const s = self as any
      return (hasParent(self, 2) && whereUsed([s.id], getParent(self, 2))[s.id]) || []
    }
  }))
